import Pqp from "../../3x1010/Pqp.js";
import Styler from "../maze/featurer/Styler.js";
import Maze from "../maze/Maze.js";
import TileMap from "../screen/tilemap/TileMap.js";

export default class SpriteProvider {
	constructor(sheets) {
		this.sheets = sheets;
		//this.style = Pqp.rnd(3);
	}

	getPos(a) {
		let ret = new Array();
		let top = a[0];
		let left = a[1];
		let bottom = a[2];
		let right = a[3];
		//console.log(top,left,bottom,right)
		for (let row = top; row <= bottom; row++) {
			for (let col = left; col <= right; col++) {
				ret.push({ row: row, col: col });
			}
		}
		//console.log(ret)
		return ret;
	}

	getFloor() {
		let sheet = this.sheets.getSpriteSheet(Styler.FLOOR);
		let rows = sheet.sprites.length;
		let cols = sheet.sprites[0].length;
		//console.log(rows,cols)

		let floors = [0, 0, rows - 1, cols - 1];
		let pos = this.getPos(floors);
		let sprites = new Array();
		for (let x = 0; x < pos.length; x++) {
			sprites.push(this.sheets.getSprite(Styler.FLOOR, pos[x].row, pos[x].col));
		}
		return sprites[Pqp.rnd(sprites.length - 1)];
	}

	getWall(pattern) {
		//let walls = [8, 0, 11, 4];
		let walls = [0, 0, 3, 4];
		let pos = this.getPos(walls);
		let chosen;

		if (pattern == "0000") {
			// Nessun muro attorno
			chosen = [0];
		} else if (pattern == "0001") {
			// ha un muro a W
			chosen = [3];
		} else if (pattern == "0010") {
			// S
			chosen = [5];
		} else if (pattern == "0011") {
			// S W
			chosen = [7];
		} else if (pattern == "0100") {
			// E
			chosen = [1];
		} else if (pattern == "0101") {
			// E W
			chosen = [2, 4, 9];
		} else if (pattern == "0110") {
			// E S
			chosen = [6];
		} else if (pattern == "0111") {
			// E S W
			chosen = [17];
		} else if (pattern == "1000") {
			// N
			chosen = [15];
		} else if (pattern == "1001") {
			// N W
			chosen = [12];
		} else if (pattern == "1010") {
			// N S
			chosen = [10, 14, 19];
		} else if (pattern == "1011") {
			// N S W
			chosen = [16];
		} else if (pattern == "1100") {
			// N E
			chosen = [11];
		} else if (pattern == "1101") {
			// N E W
			chosen = [13];
		} else if (pattern == "1110") {
			// N E S
			chosen = [18];
		} else if (pattern == "1111") {
			// N E S W
			chosen = [8];
		}
		let ret = new Array();
		for (let x = 0; x < chosen.length; x++) {
			let which = chosen[x];
			ret.push(this.sheets.getSprite(Styler.WALLS, pos[which].row, pos[which].col));
		}
		return ret[Pqp.rnd(ret.length - 1)];
	}

	getDoor(pattern) {
		/*let ret = new Array();
		if (pattern == "0101") {
			// E W
			ret.push(this.sheets.getSprite("door0", 0, 0))
		} else if (pattern == "1010") {
			// N S
			ret.push(this.sheets.getSprite("door1", 1, 1))
			ret.push(this.sheets.getSprite("door1", 0, 1))
		} else {
			console.log("AZZ")
			console.log(cell)
			console.log(pattern)
		}
		return ret;
		*/
		let ret = null;
		if (pattern === "0101") {
			// E W
			ret = this.sheets.getSprite(Styler.DOOR_HORIZONTAL_OPENEND, 1, 9);
		} else if (pattern === "1010") {
			// N S
			ret = this.sheets.getSprite(Styler.DOOR_VERTICAL_OPENEND, 1, 9);
		}
		return ret;
	}

	/*
	getDoorPiece() {
		let ret = new Array();
		ret.push(this.sheets.getSprite("door1", 0, 1))
		return ret;
	}*/

	getEntrance(dir) {
		let ret;
		if (dir === Maze.DIR_N) {
			ret = this.sheets.getSprite(Styler.ENTER_EXIT, 0, 0);
		}
		if (dir === Maze.DIR_S) {
			ret = this.sheets.getSprite(Styler.ENTER_EXIT, 0, 0);
		}
		if (dir === Maze.DIR_E) {
			ret = this.sheets.getSprite(Styler.ENTER_EXIT, 1, 1);
		}
		if (dir === Maze.DIR_W) {
			ret = this.sheets.getSprite(Styler.ENTER_EXIT, 1, 1);
		}

		return ret;
	}

	getExit(dir) {
		let ret;
		if (dir === Maze.DIR_N) {
			ret = this.sheets.getSprite(Styler.ENTER_EXIT, 1, 0);
		}
		if (dir === Maze.DIR_S) {
			ret = this.sheets.getSprite(Styler.ENTER_EXIT, 1, 0);
		}
		if (dir === Maze.DIR_E) {
			ret = this.sheets.getSprite(Styler.ENTER_EXIT, 1, 0);
		}
		if (dir === Maze.DIR_W) {
			ret = this.sheets.getSprite(Styler.ENTER_EXIT, 1, 0);
		}

		return ret;
	}

	getEntrancePiece() {
		let ret = new Array();
		ret = this.sheets.getSprite(Styler.ENTER_EXIT, 0, 1);
		return ret;
	}

	getArch(pattern) {
		let row, col
		if (pattern === 0) {
			row = 1;
			col = 0;
		} else if (pattern === 1) {
			row = 1;
			col = 1;
		} else if (pattern === 2) {
			row = 1;
			col = 2;

		} else if (pattern === 3) {
			row = 2;
			col = 0;
		} else if (pattern === 4) {
			row = 2;
			col = 1;
		} else if (pattern === 5) {
			row = 2;
			col = 2;
		}
		let ret = this.sheets.getSprite(Styler.ARCHES, row, col);
		return ret;
	}

	getWallArch(pattern) {
		let ret
		if (pattern === 0) {
			ret = this.sheets.getSprite(Styler.ARCHES, 0, 0);
		}
		if (pattern === 1) {
			ret = this.sheets.getSprite(Styler.ARCHES, 0, 1);
		}
		return ret;
	}

	getPaving(n, r, c) {
		let pavings = TileMap.STYLER.kit.paving;
		let sheet = this.sheets.getSpriteSheet(pavings[n]);
		let rowd = sheet.sprites.length;
		let cold = sheet.sprites[0].length;

		let ret;
		let row = r % rowd;
		let col = c % cold;
		ret = this.sheets.getSprite(pavings[n], row, col);
		return ret;
	}

	getColumn(row, n) {
		let ret = this.sheets.getSprite(Styler.COLUMNS, row, n - 1);
		return ret;
	}

	getTorchWall(lit) {
		let ret;
		if (lit) {
			ret = this.sheets.getSprite(Styler.WALLS, 0, 5);
		} else {
			ret = this.sheets.getSprite(Styler.WALLS, 0, 6);
		}
		return ret;
	}


	getIdleDebug(n) {
		let ret = this.sheets.getSprite("hero", 0, n);
		return ret;
	}

	getSprite(id, row, col) {
		return this.sheets.getSprite(id, row, col);
	}



}